// Database COMPLETO di interventi predefiniti per categoria officina
// Ogni intervento è organizzato in sottosezioni cliccabili (chip)
// L'operatore seleziona quello eseguito con un singolo click

export const WORKSHOP_CATEGORIES = [
  { value: "meccanica", label: "Meccanica", color: "#ff5577", icon: "Wrench" },
  { value: "carrozzeria", label: "Carrozzeria", color: "#ffaa44", icon: "Paintbrush" },
  { value: "elettrauto", label: "Elettrauto", color: "#44aaff", icon: "Zap" },
  { value: "gommista", label: "Gommista", color: "#88dd44", icon: "Disc" },
  { value: "tagliando_periodico", label: "Tagliando", color: "#aa88ff", icon: "Calendar" },
  { value: "revisione", label: "Revisione", color: "#ff88dd", icon: "FileCheck" },
  { value: "altro", label: "Altro", color: "#888888", icon: "MoreHorizontal" },
];

// Interventi organizzati in sottosezioni → chip cliccabili
// Struttura: { sottosezione: ["intervento1", "intervento2", ...] }
export const INTERVENTI_BY_CATEGORIA = {
  meccanica: {
    "Freni": [
      "Sostituzione pastiglie freni anteriori",
      "Sostituzione pastiglie freni posteriori",
      "Sostituzione dischi freni anteriori",
      "Sostituzione dischi freni posteriori",
      "Sostituzione kit completo freni anteriori (dischi + pastiglie)",
      "Sostituzione kit completo freni posteriori",
      "Sostituzione tamburi freni posteriori",
      "Sostituzione ganasce freno a mano",
      "Sostituzione liquido freni",
      "Sostituzione pinza freno SX",
      "Sostituzione pinza freno DX",
      "Sostituzione tubo freno",
      "Spurgo impianto frenante",
      "Riparazione servofreno",
      "Sostituzione pompa freno",
      "Regolazione freno a mano",
    ],
    "Sospensioni & Sterzo": [
      "Sostituzione ammortizzatore anteriore SX",
      "Sostituzione ammortizzatore anteriore DX",
      "Sostituzione ammortizzatori anteriori (coppia)",
      "Sostituzione ammortizzatore posteriore SX",
      "Sostituzione ammortizzatore posteriore DX",
      "Sostituzione ammortizzatori posteriori (coppia)",
      "Sostituzione molle sospensione",
      "Sostituzione braccetto sospensione SX",
      "Sostituzione braccetto sospensione DX",
      "Sostituzione braccetti sospensione (coppia)",
      "Sostituzione testina sterzo SX",
      "Sostituzione testina sterzo DX",
      "Sostituzione tirante scatola sterzo",
      "Sostituzione scatola sterzo",
      "Sostituzione barra stabilizzatrice anteriore",
      "Sostituzione barra stabilizzatrice posteriore",
      "Sostituzione biellette stabilizzatrice",
      "Sostituzione cuscinetto ruota anteriore SX",
      "Sostituzione cuscinetto ruota anteriore DX",
      "Sostituzione cuscinetto ruota posteriore SX",
      "Sostituzione cuscinetto ruota posteriore DX",
      "Sostituzione semiasse SX",
      "Sostituzione semiasse DX",
      "Sostituzione cuffia semiasse",
      "Sostituzione silent block",
      "Sostituzione supporto motore",
    ],
    "Motore - Olio & Filtri": [
      "Cambio olio motore + filtro",
      "Cambio olio motore (solo olio)",
      "Sostituzione filtro olio",
      "Sostituzione filtro aria",
      "Sostituzione filtro abitacolo (polline)",
      "Sostituzione filtro carburante (gasolio)",
      "Sostituzione filtro carburante (benzina)",
      "Sostituzione filtro DPF",
    ],
    "Motore - Cinghie & Distribuzione": [
      "Sostituzione cinghia distribuzione",
      "Sostituzione kit distribuzione completo",
      "Sostituzione cinghia servizi (alternatore)",
      "Sostituzione catena distribuzione",
      "Sostituzione tendicatena",
      "Sostituzione tendicinghia",
      "Sostituzione puleggia albero motore",
      "Sostituzione puleggia alternatore",
    ],
    "Motore - Raffreddamento": [
      "Sostituzione pompa acqua",
      "Sostituzione termostato",
      "Sostituzione radiatore acqua",
      "Sostituzione radiatore olio",
      "Sostituzione liquido refrigerante",
      "Sostituzione manicotti raffreddamento",
      "Sostituzione ventola radiatore",
      "Spurgo impianto raffreddamento",
      "Riparazione perdita radiatore",
    ],
    "Motore - Iniezione & Alimentazione": [
      "Sostituzione iniettore SX",
      "Sostituzione iniettore DX",
      "Sostituzione iniettori (set completo)",
      "Pulizia iniettori",
      "Sostituzione candele",
      "Sostituzione candelette (diesel)",
      "Sostituzione pompa carburante",
      "Sostituzione regolatore pressione",
      "Sostituzione corpo farfallato",
      "Pulizia corpo farfallato",
      "Sostituzione sonda lambda",
      "Sostituzione debimetro (MAF)",
      "Sostituzione sensore MAP",
    ],
    "Motore - Scarico & FAP": [
      "Riparazione marmitta",
      "Sostituzione marmitta posteriore",
      "Sostituzione catalizzatore",
      "Sostituzione FAP/DPF",
      "Rigenerazione FAP/DPF",
      "Sostituzione AdBlue / iniettore urea",
      "Sostituzione valvola EGR",
      "Pulizia valvola EGR",
      "Sostituzione collettore di scarico",
      "Sostituzione guarnizione scarico",
    ],
    "Motore - Turbina & Sovralimentazione": [
      "Sostituzione turbina",
      "Riparazione turbina",
      "Sostituzione tubo turbina",
      "Sostituzione intercooler",
      "Sostituzione valvola wastegate",
    ],
    "Trasmissione & Cambio": [
      "Sostituzione frizione (kit completo)",
      "Sostituzione spingidisco",
      "Sostituzione cuscinetto reggispinta",
      "Sostituzione volano bimassa",
      "Cambio olio cambio manuale",
      "Cambio olio cambio automatico",
      "Sostituzione filtro cambio automatico",
      "Sostituzione differenziale",
      "Sostituzione olio differenziale",
      "Sostituzione albero di trasmissione",
      "Sostituzione crociera albero trasmissione",
      "Sostituzione frizione idraulica",
    ],
    "Motore - Diagnosi & Riparazione": [
      "Diagnosi elettronica avanzata",
      "Cancellazione codici errore (centralina)",
      "Riparazione testata motore",
      "Sostituzione guarnizione testata",
      "Riparazione motore (revisione completa)",
      "Sostituzione albero motore",
      "Sostituzione bronzine biella",
      "Sostituzione bronzine banco",
      "Sostituzione pistoni",
      "Sostituzione fasce pistoni",
    ],
  },

  carrozzeria: {
    "Paraurti & Mascherina": [
      "Sostituzione paraurti anteriore",
      "Sostituzione paraurti posteriore",
      "Riparazione paraurti anteriore",
      "Riparazione paraurti posteriore",
      "Sostituzione mascherina anteriore (griglia)",
      "Sostituzione fascione paraurti",
      "Sostituzione spoiler anteriore",
      "Sostituzione spoiler posteriore",
    ],
    "Portiere & Cofani": [
      "Sostituzione portiera anteriore SX",
      "Sostituzione portiera anteriore DX",
      "Sostituzione portiera posteriore SX",
      "Sostituzione portiera posteriore DX",
      "Sostituzione portellone posteriore",
      "Sostituzione cofano motore",
      "Sostituzione serratura portiera SX",
      "Sostituzione serratura portiera DX",
      "Sostituzione maniglia esterna portiera SX",
      "Sostituzione maniglia esterna portiera DX",
      "Sostituzione cerniera portiera",
      "Allineamento portiera",
      "Sostituzione guarnizione portiera",
    ],
    "Parafanghi & Carrozzeria": [
      "Sostituzione parafango anteriore SX",
      "Sostituzione parafango anteriore DX",
      "Sostituzione parafango posteriore SX",
      "Sostituzione parafango posteriore DX",
      "Sostituzione brancardo SX",
      "Sostituzione brancardo DX",
      "Sostituzione passaruota interno",
      "Raddrizzatura scocca",
      "Saldatura sottoscocca",
      "Trattamento ruggine",
    ],
    "Specchietti & Retrovisori": [
      "Sostituzione specchietto retrovisore SX completo",
      "Sostituzione specchietto retrovisore DX completo",
      "Sostituzione vetro specchietto SX",
      "Sostituzione vetro specchietto DX",
      "Sostituzione copertura specchietto",
      "Riparazione motorino specchietto",
    ],
    "Vetri": [
      "Sostituzione parabrezza",
      "Riparazione bollatura parabrezza",
      "Sostituzione lunotto posteriore",
      "Sostituzione vetro porta anteriore SX",
      "Sostituzione vetro porta anteriore DX",
      "Sostituzione vetro porta posteriore SX",
      "Sostituzione vetro porta posteriore DX",
      "Sostituzione vetro laterale fisso",
      "Sostituzione vetro tetto apribile",
    ],
    "Verniciatura": [
      "Verniciatura paraurti anteriore",
      "Verniciatura paraurti posteriore",
      "Verniciatura portiera anteriore SX",
      "Verniciatura portiera anteriore DX",
      "Verniciatura portiera posteriore SX",
      "Verniciatura portiera posteriore DX",
      "Verniciatura parafango",
      "Verniciatura cofano",
      "Verniciatura tetto",
      "Verniciatura totale auto",
      "Verniciatura parziale (zona limitata)",
      "Ritocco vernice (graffio)",
      "Lucidatura completa carrozzeria",
      "Trattamento ceramico/nano",
      "Wrapping pellicola",
    ],
    "Bollature & Ammaccature": [
      "Riparazione bollatura (PDR - senza vernice)",
      "Riparazione ammaccatura grande",
      "Riparazione danno grandine completo",
      "Stuccatura e riparazione lamiera",
    ],
    "Fanaleria": [
      "Sostituzione faro anteriore SX",
      "Sostituzione faro anteriore DX",
      "Sostituzione faro posteriore SX",
      "Sostituzione faro posteriore DX",
      "Sostituzione fendinebbia SX",
      "Sostituzione fendinebbia DX",
      "Lucidatura fari ossidati",
      "Sostituzione faro retromarcia",
      "Sostituzione luce targa",
    ],
    "Interni Carrozzeria": [
      "Sostituzione tappezzeria sedile SX",
      "Sostituzione tappezzeria sedile DX",
      "Sostituzione pannello porta SX",
      "Sostituzione pannello porta DX",
      "Sostituzione cielo abitacolo",
      "Sostituzione moquette",
      "Riparazione plastica interni",
    ],
    "Tetti & Capote": [
      "Sostituzione tetto apribile",
      "Riparazione tetto panoramico",
      "Sostituzione capote (cabrio)",
      "Riparazione meccanismo capote",
    ],
  },

  elettrauto: {
    "Batteria & Avviamento": [
      "Sostituzione batteria 60Ah",
      "Sostituzione batteria 70Ah",
      "Sostituzione batteria 80Ah",
      "Sostituzione batteria 90Ah",
      "Sostituzione batteria 100Ah",
      "Sostituzione batteria AGM Start&Stop",
      "Test e ricarica batteria",
      "Sostituzione cavi batteria",
      "Sostituzione alternatore",
      "Sostituzione cinghia alternatore",
      "Riparazione alternatore",
      "Sostituzione motorino di avviamento",
      "Riparazione motorino di avviamento",
      "Sostituzione regolatore tensione",
    ],
    "Centraline & Diagnosi": [
      "Diagnosi centralina motore (ECU)",
      "Riprogrammazione ECU",
      "Sostituzione centralina motore",
      "Sostituzione centralina cambio",
      "Codifica nuova centralina",
      "Reset spia errore motore",
      "Aggiornamento firmware ECU",
      "Sostituzione centralina ABS",
      "Sostituzione centralina airbag",
      "Sostituzione BCM (Body Control Module)",
    ],
    "Sensori": [
      "Sostituzione sensore ABS anteriore SX",
      "Sostituzione sensore ABS anteriore DX",
      "Sostituzione sensore ABS posteriore SX",
      "Sostituzione sensore ABS posteriore DX",
      "Sostituzione sonda lambda pre-cat",
      "Sostituzione sonda lambda post-cat",
      "Sostituzione sensore temperatura motore",
      "Sostituzione sensore pressione olio",
      "Sostituzione sensore pressione carburante",
      "Sostituzione sensore albero motore",
      "Sostituzione sensore camme",
      "Sostituzione sensore parcheggio anteriore",
      "Sostituzione sensore parcheggio posteriore",
      "Sostituzione sensore pioggia",
      "Sostituzione sensore crepuscolare",
    ],
    "Climatizzazione A/C": [
      "Ricarica gas climatizzatore R134a",
      "Ricarica gas climatizzatore R1234yf",
      "Sostituzione compressore A/C",
      "Sostituzione condensatore A/C",
      "Sostituzione evaporatore A/C",
      "Sostituzione filtro disidratatore",
      "Sostituzione valvola di espansione",
      "Sanificazione impianto A/C (ozono)",
      "Diagnosi perdita gas A/C",
      "Riparazione tubazioni A/C",
      "Sostituzione resistenza ventola abitacolo",
      "Sostituzione ventola abitacolo",
    ],
    "Impianto Elettrico": [
      "Riparazione cablaggio",
      "Sostituzione fusibile",
      "Sostituzione relè",
      "Sostituzione interruttore luci",
      "Sostituzione interruttore alzavetri",
      "Sostituzione alzavetro elettrico SX",
      "Sostituzione alzavetro elettrico DX",
      "Sostituzione motorino tergicristalli",
      "Sostituzione braccetto tergicristalli",
      "Sostituzione spazzole tergicristalli",
      "Sostituzione lampade fari",
      "Conversione fari LED",
      "Sostituzione clacson",
    ],
    "Centralizzazione & Sicurezza": [
      "Riprogrammazione telecomando chiave",
      "Duplicazione chiave con transponder",
      "Sostituzione blocco accensione",
      "Riparazione chiusura centralizzata",
      "Sostituzione antenna immobilizer",
      "Installazione antifurto",
      "Installazione tracker GPS",
      "Installazione telecamera retromarcia",
    ],
    "Multimedia & Comfort": [
      "Installazione autoradio",
      "Sostituzione altoparlanti",
      "Installazione vivavoce Bluetooth",
      "Installazione caricabatteria USB",
      "Aggiornamento sistema infotainment",
      "Sostituzione display multimediale",
      "Riparazione comandi al volante",
    ],
  },

  gommista: {
    "Pneumatici 13-15\"": [
      "Sostituzione 4 pneumatici 165/70 R13",
      "Sostituzione 4 pneumatici 175/65 R14",
      "Sostituzione 4 pneumatici 185/60 R14",
      "Sostituzione 4 pneumatici 185/65 R15",
      "Sostituzione 4 pneumatici 195/65 R15",
    ],
    "Pneumatici 16-17\"": [
      "Sostituzione 4 pneumatici 195/55 R16",
      "Sostituzione 4 pneumatici 205/55 R16",
      "Sostituzione 4 pneumatici 215/55 R16",
      "Sostituzione 4 pneumatici 215/60 R16",
      "Sostituzione 4 pneumatici 205/50 R17",
      "Sostituzione 4 pneumatici 215/45 R17",
      "Sostituzione 4 pneumatici 225/45 R17",
      "Sostituzione 4 pneumatici 225/55 R17",
    ],
    "Pneumatici 18\"+": [
      "Sostituzione 4 pneumatici 225/40 R18",
      "Sostituzione 4 pneumatici 235/40 R18",
      "Sostituzione 4 pneumatici 235/45 R18",
      "Sostituzione 4 pneumatici 245/40 R18",
      "Sostituzione 4 pneumatici 245/45 R18",
      "Sostituzione 4 pneumatici 255/40 R19",
      "Sostituzione 4 pneumatici 255/45 R19",
      "Sostituzione 4 pneumatici 265/35 R19",
      "Sostituzione 4 pneumatici 275/35 R20",
      "Sostituzione 4 pneumatici 285/30 R20",
    ],
    "Tipo gomme": [
      "4 pneumatici estivi",
      "4 pneumatici invernali",
      "4 pneumatici 4 stagioni (All Season)",
      "2 pneumatici anteriori",
      "2 pneumatici posteriori",
      "1 pneumatico singolo",
      "Pneumatici runflat",
    ],
    "Servizi": [
      "Cambio gomme stagionale (montaggio)",
      "Equilibratura ruote",
      "Convergenza ruote (assetto bi-dimensionale)",
      "Convergenza 4 ruote (assetto tridimensionale)",
      "Riparazione foratura",
      "Riparazione fianco gomma",
      "Sostituzione valvola pneumatici",
      "Sostituzione/programmazione sensori TPMS",
      "Reset sistema TPMS",
      "Stoccaggio pneumatici stagionale",
      "Smaltimento pneumatici usati",
    ],
    "Cerchi": [
      "Sostituzione cerchio in lega 15\"",
      "Sostituzione cerchio in lega 16\"",
      "Sostituzione cerchio in lega 17\"",
      "Sostituzione cerchio in lega 18\"",
      "Sostituzione cerchio in lega 19\"",
      "Sostituzione cerchio in lega 20\"",
      "Riparazione cerchio in lega",
      "Verniciatura cerchi",
      "Diamantatura cerchio",
      "Sostituzione bulloni/colonnette",
      "Catene da neve",
    ],
  },

  tagliando_periodico: {
    "Tagliandi standard": [
      "Tagliando completo 15.000 km",
      "Tagliando completo 20.000 km",
      "Tagliando completo 30.000 km",
      "Tagliando completo 40.000 km",
      "Tagliando completo 60.000 km",
      "Tagliando completo 90.000 km",
      "Tagliando completo 120.000 km",
    ],
    "Tagliandi premium": [
      "Tagliando BMW (Service Inspection)",
      "Tagliando Mercedes Service A",
      "Tagliando Mercedes Service B",
      "Tagliando Audi (Service Esteso)",
      "Tagliando Volkswagen (LongLife)",
      "Tagliando Ferrari/Porsche/Maserati",
    ],
    "Tagliandi specifici": [
      "Tagliando intermedio (olio + filtri)",
      "Tagliando GPL (revisione impianto)",
      "Tagliando Metano (revisione bombole)",
      "Controllo pre-revisione",
      "Controllo pre-viaggio lungo",
      "Tagliando elettrico (auto EV)",
      "Tagliando ibrido (batteria HV)",
    ],
  },

  revisione: {
    "Revisione veicoli leggeri": [
      "Revisione Ministeriale autovettura (MCTC)",
      "Revisione presso centro autorizzato",
      "Pre-revisione + ripristino conformità",
      "Revisione moto/scooter",
      "Revisione quad",
    ],
    "Revisione gas": [
      "Revisione impianto GPL (4 anni)",
      "Revisione bombole CNG/Metano (4 anni)",
      "Sostituzione bombole metano",
    ],
    "Revisione veicoli commerciali": [
      "Revisione furgone fino 3.5T",
      "Revisione autocarro oltre 3.5T",
      "Revisione veicolo trasporto persone",
      "Cronotachigrafo - verifica/calibrazione",
    ],
  },

  altro: {
    "Pulizia & Sanificazione": [
      "Lavaggio esterno completo",
      "Lavaggio esterno + interni",
      "Lavaggio motore",
      "Sanificazione abitacolo (ozono)",
      "Sanificazione climatizzatore",
      "Pulizia tappezzeria a vapore",
      "Trattamento sedili in pelle",
      "Pulizia bagagliaio",
      "Sgrassaggio sottoscocca",
    ],
    "Soccorso & Logistica": [
      "Carro attrezzi / recupero stradale",
      "Trasporto veicolo su piazzale",
      "Custodia veicolo (al giorno)",
      "Trasferimento veicolo tra sedi",
    ],
    "Accessori": [
      "Sostituzione tappetini",
      "Installazione kit aggancio rimorchio",
      "Installazione barre portatutto",
      "Installazione pellicole oscuranti",
      "Aggiornamento mappe navigatore",
      "Installazione paraspruzzi",
      "Sostituzione antenna",
    ],
    "Altro": [
      "Intervento personalizzato (vedi nota)",
      "Preventivo non accettato",
      "Diagnosi senza intervento",
    ],
  },
};

// Ricambi comuni per categoria (autocomplete)
export const RICAMBI_COMUNI = {
  meccanica: [
    "Pastiglie freni anteriori", "Pastiglie freni posteriori",
    "Dischi freno anteriori (coppia)", "Dischi freno posteriori (coppia)",
    "Filtro olio", "Filtro aria", "Filtro abitacolo", "Filtro carburante",
    "Olio motore 5W30 5L", "Olio motore 5W40 5L", "Olio motore 0W20 5L",
    "Candele NGK (4 pz)", "Candelette diesel (4 pz)",
    "Kit distribuzione completo", "Cinghia servizi",
    "Pompa acqua", "Termostato", "Liquido refrigerante 5L",
    "Olio cambio 1L", "Olio servosterzo",
    "Kit frizione completo", "Volano bimassa",
    "Ammortizzatori anteriori (coppia)", "Ammortizzatori posteriori (coppia)",
    "Braccetto sospensione", "Testina sterzo", "Bielletta stabilizzatrice",
    "Cuscinetto ruota", "Silent block",
    "Iniettore", "Sonda lambda", "Catalizzatore", "Valvola EGR",
    "FAP/DPF", "Turbina",
  ],
  carrozzeria: [
    "Paraurti anteriore", "Paraurti posteriore", "Cofano motore", "Portellone",
    "Portiera anteriore SX", "Portiera anteriore DX",
    "Portiera posteriore SX", "Portiera posteriore DX",
    "Parafango anteriore", "Parafango posteriore",
    "Specchietto retrovisore SX", "Specchietto retrovisore DX",
    "Parabrezza", "Lunotto", "Vetro laterale",
    "Vernice base (litro)", "Vernice trasparente", "Stucco carrozzeria",
    "Mascherina anteriore", "Faro anteriore SX", "Faro anteriore DX",
    "Faro posteriore SX", "Faro posteriore DX", "Fendinebbia",
  ],
  elettrauto: [
    "Batteria 60Ah", "Batteria 70Ah", "Batteria 80Ah", "Batteria 100Ah",
    "Batteria AGM Start&Stop",
    "Alternatore", "Motorino avviamento",
    "Sensore ABS", "Sonda lambda", "Sensore temperatura", "Sensore pressione olio",
    "Compressore A/C", "Gas R134a (kg)", "Gas R1234yf (kg)",
    "Centralina ECU", "Telecomando chiave", "Transponder",
    "Lampada H7", "Lampada H4", "Lampada LED H7",
    "Spazzole tergicristalli", "Motorino tergicristalli",
  ],
  gommista: [
    "Pneumatico 165/70 R13", "Pneumatico 185/65 R15", "Pneumatico 195/65 R15",
    "Pneumatico 205/55 R16", "Pneumatico 215/55 R16", "Pneumatico 215/60 R16",
    "Pneumatico 225/45 R17", "Pneumatico 225/55 R17",
    "Pneumatico 235/45 R18", "Pneumatico 245/45 R18", "Pneumatico 255/40 R19",
    "Cerchio in lega 16\"", "Cerchio in lega 17\"", "Cerchio in lega 18\"", "Cerchio in lega 19\"",
    "Valvola TPMS", "Sensore TPMS", "Catene da neve",
  ],
  tagliando_periodico: [
    "Olio motore tagliando", "Kit filtri completo",
    "Olio cambio", "Liquido raffreddamento", "Liquido freni",
  ],
  revisione: [
    "Bollo revisione MCTC",
  ],
  altro: [
    "Detergente specifico", "Cera lucidante", "Sigillante",
  ],
};
